import { render, staticRenderFns } from "./RegistSuccess.vue?vue&type=template&id=8c665820&scoped=true"
import script from "./RegistSuccess.vue?vue&type=script&lang=js"
export * from "./RegistSuccess.vue?vue&type=script&lang=js"
import style0 from "./RegistSuccess.vue?vue&type=style&index=0&id=8c665820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c665820",
  null
  
)

export default component.exports